import { ReportingShellControllerBaseConfig } from '../../../base';
import { TreeItemController } from './treeItemInterface';
import { TreeItemViewProps, TreeItemControllerProps } from './treeItemProps';
import { TreeItem } from './treeItemModel';
import { HiOutlineTrash, HiOutlineStar, HiOutlineDocumentText } from 'react-icons/hi';
import { MdOutlineDriveFileRenameOutline } from 'react-icons/md';
import { createContentItemController } from '../../../../route/view';

export function createTreeItemController(
    config: ReportingShellControllerBaseConfig
): TreeItemController {
    const itemController = createContentItemController(config);
    return {
        useProps(context, item, props): TreeItemViewProps {
            const contentItem = itemController.useProps(context, item, props.item);
            const hasChildren = item.children.length > 0;
            return {
                id: item.id,
                isExpanded: props.expanded.value,
                isCurrent: props.current,
                label: item.label,
                hasChildren,
                depth: props.depth,
                icon: item.icon ?? {
                    kind: 'icon',
                    Component: HiOutlineDocumentText,
                },
                link: item.path
                    ? {
                          to: item.path,
                      }
                    : null,
                container: {
                    // onClick(event) {
                    //     // toggle expanded state if item has no path
                    //     if (hasChildren && !props.current) {
                    //         props.expanded.onChange(true);
                    //     }
                    // },
                },
                expand: {
                    button: {
                        onClick(event) {
                            event.stopPropagation();
                            event.preventDefault();
                            props.expanded.onChange(!props.expanded.value);
                        },
                    },
                },
                menu: {
                    isOpen: props.menu.isOpen,
                    onOpen: props.menu.onOpen,
                    onClose: props.menu.onClose,
                    trigger: {
                        button: {
                            onClick(event) {
                                event.stopPropagation();
                                event.preventDefault();
                                props.menu.isOpen
                                    ? props.menu.onClose()
                                    : props.menu.onOpen();
                            },
                        },
                    },
                    items: [
                        {
                            kind: 'item',
                            label: 'Add to favorites',
                            Icon: HiOutlineStar,
                            colorScheme: null,
                            onClick(event) {
                                event.stopPropagation();
                                event.preventDefault();
                                console.log('add to favorites');
                            },
                        },
                        {
                            kind: 'divider',
                        },
                        {
                            kind: 'item',
                            label: 'Rename',
                            Icon: MdOutlineDriveFileRenameOutline,
                            colorScheme: null,
                            onClick(event) {
                                event.stopPropagation();
                                event.preventDefault();
                                console.log('rename');
                            },
                        },
                        {
                            kind: 'item',
                            label: contentItem.archive.label,
                            Icon: contentItem.archive.Icon,
                            colorScheme: 'red',
                            onClick: contentItem.archive.button.onClick ?? null,
                        },
                    ],
                },
            };
        },
    };
}
